<div class="wsu-main">
  <app-impersonation-confirm-modal
    testId="impersonate-tunnel-dialog"
    *ngIf="confirmVisible && confirmTunnel"
    titleId="wsu-tunnel-confirm-title"
    title="Impersonate tunnel"
    [busy]="!!busyKey"
    (cancel)="closeConfirm()"
    (confirm)="onConfirmImpersonate()"
  >
    Start an impersonation session for
    <strong
      >“{{
        confirmTunnel.branch || confirmTunnel.location_name || confirmTunnel.email || 'this tunnel'
      }}”</strong
    >
    <span *ngIf="confirmTunnel.email && (confirmTunnel.branch || confirmTunnel.location_name)">
      ({{ confirmTunnel.email }})
    </span>
    at <strong>{{ companyName() }}</strong
    >? A new tab will open with the tunnel session.
  </app-impersonation-confirm-modal>

  <div class="wsu-filters">
    <div class="wsu-filter-field wsu-filter-field--search">
      <label class="wsu-label" for="tunnel-search">Search tunnels</label>
      <input
        id="tunnel-search"
        class="form-control"
        type="search"
        placeholder="Search by branch, email, city, contact…"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchInput($event)"
      />
    </div>
  </div>

  <div class="wsu-state" *ngIf="loadingTunnels">Loading tunnels…</div>
  <div class="wsu-state wsu-state--error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <app-impersonation-empty-state
    testId="impersonate-tunnel-empty-state"
    *ngIf="!loadingTunnels && !errorMessage && tunnels.length === 0"
    icon="tunnel"
    title="No Tunnels Found"
    text="This shop doesn’t have any tunnel users matching your current search. Try clearing search."
    [hint]="'No tunnels available for ' + (companyName() || 'this shop')"
  ></app-impersonation-empty-state>

  <div class="wsu-table-wrap" *ngIf="!loadingTunnels && tunnels.length > 0">
    <table class="wsu-table">
      <thead>
        <tr>
          <th>Email</th>
          <th>Branch</th>
          <th>City</th>
          <th>Contact</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tunnel of tunnels">
          <td>{{ tunnel.email || '—' }}</td>
          <td>{{ tunnel.branch || tunnel.location_name || '—' }}</td>
          <td>{{ tunnel.city || '—' }}</td>
          <td>{{ tunnel.contact || '—' }}</td>
          <td>
            <span class="wsu-pill" [class.wsu-pill--off]="tunnel.is_active === false">
              {{ tunnel.is_active === false ? 'Inactive' : 'Active' }}
            </span>
          </td>
          <td class="wsu-table__action">
            <button
              type="button"
              class="btn btn-primary btn-medium"
              [disabled]="busyKey === tunnel.id || confirmVisible"
              (click)="impersonate(tunnel)"
            >
              {{ busyKey === tunnel.id ? 'Opening…' : 'Impersonate' }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <app-pagination-bar
    *ngIf="totalItems > 0"
    [paginationData]="paginationData"
    [itemsPerPageOptions]="[10, 25, 50]"
    (pageChange)="onPageChange($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
  ></app-pagination-bar>
</div>
